module.exports = __webpack_public_path__ + "img/Ginning.1dcd15fe.png";